

<template>
  <div>
    <div class="">
      <b-card
        class="col-12"
        border-variant="primary"
      >
        <b-form-group v-slot="{ ariaDescribedby }">
          <label 
            for="radios-stacked"
            style="font-size: medium;"
            class="mb-1"
          >
            Siente Fatiga:
          </label>

          <b-form-radio-group
            v-model="nyha.fatiga"
            :options="optionsFatiga"
            :aria-describedby="ariaDescribedby"
            name="radios-fatiga"
            stacked
          />
        </b-form-group>
      </b-card>

      <b-card
        class="col-12"
        border-variant="primary"
      >
        <b-form-group v-slot="{ ariaDescribedby }">
          <label 
            for="radios-stacked"
            style="font-size: medium;"
            class="mb-1"
          >
            Dificul respiratoria (Disnea) :
          </label>
          <b-form-radio-group
            v-model="nyha.respirar"
            :options="optionsRespirar"
            :aria-describedby="ariaDescribedby"
            name="radios-respirar"
            stacked
          />
        </b-form-group>
      </b-card>

      <b-card
        class="col-12"
        border-variant="primary"
      >
        <b-form-group v-slot="{ ariaDescribedby }">
          <label 
            for="radios-stacked"
            style="font-size: medium;"
            class="mb-1"
          >
            Palpitaciones o dolor en el pecho:
          </label>
          <b-form-radio-group
            v-model="nyha.palpitaciones"
            :options="optionsPalpitaciones"
            :aria-describedby="ariaDescribedby"
            name="radios-palpitaciones"
            stacked
          />
        </b-form-group>
      </b-card>

      <b-card
        class="col-12"
        border-variant="primary"
      >
        <b-form-group v-slot="{ ariaDescribedby }">
          <label 
            for="radios-stacked"
            style="font-size: medium;"
            class="mb-1"
          >
            Hinchazon de piernas:
          </label>
          <b-form-radio-group
            v-model="nyha.hinchazon"
            :options="optionsFatiga"
            :aria-describedby="ariaDescribedby"
            name="radios-hinchazon"
            stacked
          />
        </b-form-group>
      </b-card>

      <b-card
        class="col-12"
        border-variant="primary"
      >
        <b-form-group v-slot="{ ariaDescribedby }">
          <label 
            for="radios-stacked"
            style="font-size: medium;"
            class="mb-1"
          >
            Episodios de mareo:
          </label>
          <b-form-radio-group
            v-model="nyha.mareos"
            :options="optionsFatiga"
            :aria-describedby="ariaDescribedby"
            name="radios-mareos"
            stacked
          />
        </b-form-group>
      </b-card>
    </div>
    
  </div>
</template>

<script>

import{ 
  BCard, 
  BFormRadioGroup, 
  BFormGroup 
} from 'bootstrap-vue';

export default {
  name: "EscalaNyha",

  data(){

    return {

      nyha:{
        fatiga           : null,
        respirar         : null,
        palpitaciones    : null,
        hinchazon        : null,
        mareos           : null
      },

      optionsFatiga: [
        { value: 1, text: 'Nunca' },
        { value: 2, text: 'Rara vez' },
        { value: 3, text: 'Ocasional' },
        { value: 4, text: 'Frecuente' },
        { value: 5, text: 'Siempre' }
      ],

      optionsRespirar: [
        { value: 1, text: 'No tengo dificultad para respirar en absoluto.' },
        { value: 2, text: 'Tengo dificultad para respirar solo con ejercicio intenso' },
        { value: 3, text: 'Tengo dificultad para respirar con actividades moderadas.' },
        { value: 4, text: 'Tengo dificultad para respirar con actividades leves.' },
        { value: 5, text: 'Tengo dificultad para respirar incluso en reposo.' }
      ],

      optionsPalpitaciones: [
        { value: 1, text: 'No tengo palpitaciones ni dolor en el pecho.' },
        { value: 2, text: 'Tengo palpitaciones o dolor en el pecho menos de una vez por semana.' },
        { value: 3, text: 'Tengo palpitaciones o dolor en el pecho una o dos veces por semana.' },
        { value: 4, text: 'Tengo palpitaciones o dolor en el pecho varios días a la semana.' },
        { value: 5, text: 'Tengo palpitaciones o dolor en el pecho todos los días.' }
      ],

    }
  },

  components: {
    BCard,
    BFormRadioGroup,
    BFormGroup,
  },


  watch: {
    nyha: {
      deep: true,
      handler(newValue){

        this.$store.commit('setNyha', newValue)
      },
    },
  },
}

</script>